import cx from 'classnames';
import PropTypes from 'prop-types';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import { useContext, useState } from 'react';
import { Carousel, Grid, GridItem, Modal } from '@bwoty-web/ui-kit';

import CabinCard from './CabinCard';
import GlobalContext from '../../context/globalContext';
import CarouselSwitchButton from '../shared/carouselSwitchButton/CarouselSwitchButton';

import './cabinList.scss';

const CabinList = ({ cabins, isChangeCabinPage, selectCabin, selectedCabinKey }) => {
  const {
    labels,
    siteSettings: { siteId },
  } = useContext(GlobalContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [readMoreCabin, setReadMoreCabin] = useState(null);
  const [showBeverageIncludedText, setShowBeverageIncludedText] = useState(false);
  const [showCardsInCarousel, setShowCardsInCarousel] = useState(true);
  const isGlobetrotter = useIsGlobetrotter();

  const toggleCardViewHandler = () => setShowCardsInCarousel((prevState) => !prevState);

  const selectCabinOnClickHandler = (cabinKey) => selectCabin(cabinKey);

  const handleReadMore = (modalCabin) => {
    setReadMoreCabin(modalCabin);
    const shouldShowBeverageText =
      modalCabin?.fareTypePrices?.some(({ beverageIncluded }) => beverageIncluded) &&
      !!modalCabin?.beverageIncludedText;
    setShowBeverageIncludedText(shouldShowBeverageText);
    setModalIsOpen(true);
  };

  const renderRoomCards = () =>
    cabins.map((cabin) => {
      const cabinCardProps = {
        cabin,
        isGlobetrotter,
        labels,
        selectCabinOnClickHandler,
        selectedCabinKey,
        siteId,
        triggerReadMoreModal: handleReadMore,
      };

      return showCardsInCarousel ? (
        <CabinCard
          key={cabin.key}
          {...cabinCardProps}
        />
      ) : (
        <GridItem
          columnSpan={4}
          key={cabin.key}
        >
          <CabinCard {...cabinCardProps} />
        </GridItem>
      );
    });

  return (
    <>
      {cabins?.length > 0 && (
        <div
          className={cx('iw-cabin-list__header-container', {
            'iw-cabin-list__header-container--changeCabinPage': isChangeCabinPage,
          })}
        >
          {!isChangeCabinPage && <h2 className="iw-cabin-list__subheading">{labels?.cabinListHeading}</h2>}
          <CarouselSwitchButton
            label={labels.carouselSwitchButtonLabel}
            showCardsInCarousel={showCardsInCarousel}
            toggleCardView={toggleCardViewHandler}
          />
        </div>
      )}
      {showCardsInCarousel ? <Carousel>{renderRoomCards()}</Carousel> : <Grid>{renderRoomCards()}</Grid>}
      <Modal
        heading={readMoreCabin?.cabinName}
        isOpen={modalIsOpen}
        onClose={() => {
          setModalIsOpen(false);
          setReadMoreCabin(null);
          setShowBeverageIncludedText(false);
        }}
      >
        <div className="iw-cabin-list-modal__container">
          <p className="iw-cabin-list-modal__paragraph">{readMoreCabin?.description}</p>
          {showBeverageIncludedText && (
            <div className="iw-cabin-list-modal__drink-package-container">
              <p className="iw-cabin-list-modal__drink-package-heading">{labels.drinkPackage}</p>
              <p>{readMoreCabin.beverageIncludedText}</p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

CabinList.propTypes = {
  cabins: PropTypes.arrayOf(
    PropTypes.shape({
      cabinName: PropTypes.string,
      key: PropTypes.string,
    }),
  ).isRequired,
  isChangeCabinPage: PropTypes.bool.isRequired,
  selectCabin: PropTypes.func.isRequired,
  selectedCabinKey: PropTypes.string.isRequired,
};

export default CabinList;
